var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportLeakage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9733 4.5H11.0267L4 11.5267V21.4733L11.0267 28.5H20.9733L28 21.4733V11.5267L20.9733 4.5ZM25.3333 20.3667L19.8667 25.8333H12.1333L6.66667 20.3667V12.6333L12.1333 7.16667H19.8667L25.3333 12.6333V20.3667V20.3667Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0013 23.1667C16.7377 23.1667 17.3346 22.5697 17.3346 21.8333C17.3346 21.097 16.7377 20.5 16.0013 20.5C15.2649 20.5 14.668 21.097 14.668 21.8333C14.668 22.5697 15.2649 23.1667 16.0013 23.1667Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.668 9.83203H17.3346V19.1654H14.668V9.83203Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportLeakage);
export default __webpack_public_path__ + "static/media/reportLeakage.64a08c411e0e3ed3c8ac4ec80e1f9536.svg";
export { ForwardRef as ReactComponent };